import { classNames } from '@fullstory/util/fmt';
import React, { PropsWithChildren } from 'react';
import { Icon, IconName } from '../../components/Icon';
import { identifyComponent } from '../../util';
import { Box } from '../Box';
import { Flex } from '../Flex';
import colors from './colors.module.scss';
import css from './index.module.scss';

export interface PillProps {
  variant: 'primary' | 'outline' | 'compact' | 'compact-outline' | 'intelligence';
  color?: keyof typeof colors;
  /**
   * External margins get applied by default (legacy).
   * This provides an override.
   *
   * Default false.
   */
  noExternalSpacing?: boolean;
  iconLeft?: IconName;
  opaque?: boolean;
}
export const Pill: React.FC<PropsWithChildren<PillProps>> = ({
  variant,
  color = 'secondary',
  noExternalSpacing = false,
  children,
  iconLeft,
  opaque = false,
}) => (
  <Box
    data-component="Pill"
    className={classNames(css.pillContainer, {
      [css.noExternalSpacing]: noExternalSpacing,
      [css.opaque]: opaque,
    })}
    {...identifyComponent('pill')}
  >
    <Flex
      className={classNames(css.pillContent, colors[color], {
        [css.outline]: variant === 'outline',
        [css.compact]: variant === 'compact',
        [css.compactOutline]: variant === 'compact-outline',
        [css.intelligence]: variant === 'intelligence',
      })}
    >
      {iconLeft && (
        <Box marginRight={4}>
          <Icon name={iconLeft} />
        </Box>
      )}
      {children}
    </Flex>
  </Box>
);
